import vExport from "./export";
export default {
  components: { vExport },
  data() {
    return {
      exportDialogVisible: false
    }
  },
  methods: {
    exportShow() {
      this.exportDialogVisible = true;
    }
  }
}